module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1165.34f180a8.png";